import React from 'react';
import {T} from '../../../../utils/I18n/I18n';

const AddressPresentation = ({ address, setEditAddressId, addressType, isOrdersbook }) => {
    const { firstname, lastname, street, city, postcode, telephone, id, company, vat_id } = address;
    let type = addressType === 'naplatu' ? 'naplatu' : 'dostavu';
    return (
        <div className="address-presentation mr-auto" key={id}>
            <span className="mini-headers"><T id="personalData.setAddress"/> {type}</span>
            <div className="address-presentation__list">
                <span>
                    {firstname} {lastname}
                </span>
                <span>{street && street.length > 0 && street[0]}</span>
                <span>
                    {city} {postcode}
                </span>
                <span><T id="address.croatia"/></span>
                <span>T: {telephone && telephone}</span>
                {company && <span>{company}</span>}
                {vat_id && <span>VAT: {vat_id}</span>}
            </div>
            {!isOrdersbook && <div className="just-link" onClick={() => setEditAddressId(id)}>
                <T id="personalData.changeAddress"/>{type}
            </div>}
        </div>
    );
};

export default AddressPresentation;
